import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Ahorra tiempo y ordena tu trabajo (legajos + seguimiento)', 'Material práctico y adaptable a tu institución (Argentina)', 'Plantillas editables + recursos listos para usar'];
export function BenefitsSection() {
  return <section className="py-16 md:py-24 px-4" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <h2 className="text-4xl md:text-5xl font-black text-center text-gray-900 mb-12 uppercase" data-id="element-13">
          Beneficios
        </h2>
        <div className="space-y-6" data-id="element-14">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 bg-white/60 backdrop-blur-sm p-6 rounded-xl border border-orange-100/50" data-id="element-15">
              <CheckCircle2 className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-16" />
              <p className="text-xl md:text-2xl font-bold text-gray-800" data-id="element-17">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}